import axios from "axios";
import { localToken, patientSearch } from "../../constants/apis/new_hud_apis";

export const searchPatientApi = async (branch, name) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localToken}`,
        },
    };

    const response = await axios.get(
        patientSearch + `?branch_name=${branch}&search_name=${name}`,
        config,
    );

    return response;
};
